import { LoginProjectConfiguration, SocialConnectionsResponse } from '../api';
import { CLASSIC_LOGIN, PASSWORDLESS_LOGIN, SOCIAL_LOGIN } from '../constants';
import { CurrentProjectType } from '../contexts/settings/types';
import { haveCustomSocialConnect } from '.';
import { haveSocialsConnect } from './haveSocialsConnect';

export const updateProjectType = (
  currProject: LoginProjectConfiguration | null,
  currentSocials: SocialConnectionsResponse | null
): CurrentProjectType => {
  if (!currProject) {
    return null;
  }

  // is_phone_auth_allowed - параметр, который отвечает за то включена у проект passwordless
  // авторизация по телефону или нет
  // is_email_auth_allowed - параметр, который отвечает за то включена у проект passwordless
  // авторизация по почте или нет
  // is_device_auth_allowed - параметр, который отвечает за то включена у проект passwordless
  // авторизация по device id
  // authentication_allowed - параметр, который отвечает за то включена у проект обычная
  // авторизация по почте и паролю
  // registration_allowed - параметр, который отвечает за то включена ли у проекта
  // регистрация по почте и паролю

  const { is_email_auth_allowed, authentication_allowed, is_phone_auth_allowed } = currProject;

  if (is_phone_auth_allowed || is_email_auth_allowed) {
    return PASSWORDLESS_LOGIN;
  }

  if (!is_email_auth_allowed && authentication_allowed) {
    return CLASSIC_LOGIN;
  }

  const haveSocials = haveSocialsConnect(currentSocials);

  const haveCustomSocial = haveCustomSocialConnect(currentSocials);
  if (haveSocials || haveCustomSocial) {
    return SOCIAL_LOGIN;
  }

  return null;
};
